export default "__VITE_ASSET__BpCERxPa__"